import * as Turbo from "@hotwired/turbo";

// Controllers such as tabs_controller keep in-page state (the active tab) in
// the URL with a plain `history.pushState`, deliberately without Turbo's own
// state object, so switching a tab stays a client side toggle instead of a
// page visit.
//
// Turbo Drive's History#onPopState ignores every entry whose state lacks its
// `turbo` key. That is what we want while the entry belongs to the page that
// is on screen. Once the user has navigated away, however, nobody restores
// those entries: going back only changed the URL and left the other page's
// DOM in place. Hand exactly those pops to Turbo.

let renderedPath = window.location.pathname;

const rememberRenderedPath = () => {
  renderedPath = window.location.pathname;
};

const restoreForeignEntry = () => {
  // Turbo's own entries are Turbo's business; it swaps the DOM itself.
  if (history.state?.turbo) return;

  // The entry belongs to the page on screen, so whichever controller pushed it
  // restores it from the URL. Nothing to swap.
  if (window.location.pathname === renderedPath) return;

  // "replace" renders the popped location and rewrites the entry with Turbo
  // state, so a later pop onto it is handled by Turbo directly.
  Turbo.visit(window.location.href, { action: "replace" });
};

document.addEventListener("turbo:load", rememberRenderedPath);
window.addEventListener("popstate", restoreForeignEntry);
